/* eslint-disable camelcase */
import apiService from 'src/enviroment';

const getVehicles = async (location) => {
  const {
    subSegment, segment, subCategory, category, id,
  } = location;
  try {
    const response = await apiService.get(
      `/mapavalor/vehiculos/?segmento=${segment}&subsegmento=${subSegment}&categoria=${category}&subcategoria=${subCategory}&territorio_id=${id}`,
    );
    if (response.status === 200) {
      return response.data.vehiculos;
    }
  } catch (error) {
    return false;
  }
};

const createValueMap = async (params) => {
  try {
    const response = await apiService.post('/mapavalor/foto/', params);
    if (response.status === 200) {
      return response.data;
    }
  } catch (error) {
    return false;
  }
};

const deleteValueMap = async (params) => {
  try {
    const response = await apiService.delete(`/mapavalor/foto/?id=${params}`);
    if (response.status === 200) {
      return response.data;
    }
  } catch (error) {
    return false;
  }
};

const getValueMap = async (location) => {
  const {
    subSegment, segment, subCategory, category, id,
  } = location;
  try {
    const response = await apiService.get(
      `/mapavalor/foto/?segmento=${segment}&subsegmento=${subSegment}&categoria=${category}&subcategoria=${subCategory}&territorio_id=${id}`,
    );
    if (response.status === 200) {
      return response.data.fotos;
    }
  } catch (error) {
    return false;
  }
};

const getVehiclesBySegmentation = async (location) => {
  const {
    subSegment,
    segment,
    subCategory,
    category,
    unidad_negocio_id,
    territorio,
  } = location;
  try {
    const response = await apiService.get(
      `/segmentacion/maestros/lineasporsubsegmento/?segmento=${segment}&subsegmento=${subSegment}&categoria=${category}&subcategoria=${subCategory}&unidad_negocio_id=${unidad_negocio_id}&territorio=${territorio}`,
    );
    if (response.status === 200) {
      return response.data.data;
    }
  } catch (error) {
    return false;
  }
};

const getProperties = async (params) => {
  try {
    const response = await apiService.get(
      `/mapavalor/propiedades/?vehiculo_id=${params.id}`,
    );
    if (response.status === 200) {
      return response.data.propiedades;
    }
  } catch (error) {
    return false;
  }
};

const createVehicle = async (newVehicle) => {
  const vehicle = {
    empresa: newVehicle.empresa,
    linea: newVehicle.linea,
    version: newVehicle.version,
    categoria: newVehicle.category,
    subcategoria: newVehicle.subCategory,
    segmento: newVehicle.segment,
    subsegmento: newVehicle.subSegment,
    imagen: newVehicle.imagen,
    precio: newVehicle.precio,
    promocion: newVehicle.promocion,
    atributos: newVehicle.atributos,
    caracteristicas: newVehicle.caracteristicas,
    uuid: newVehicle.uuid,
    unidades: newVehicle.unidades,
    territorio_id: newVehicle.id,
  };
  try {
    const response = await apiService.post('/mapavalor/vehiculos/', vehicle);
    if (response.status === 200) {
      return response.data;
    }
    return true;
  } catch (error) {
    return false;
  }
};

const getAttributes = async (location) => {
  const {
    subSegment, segment, subCategory, category,
  } = location;

  try {
    const response = await apiService.get(
      `/mapavalor/atributos/?segmento=${segment}&subsegmento=${subSegment}&categoria=${category}&subcategoria=${subCategory}`,
    );
    if (response.status === 200) {
      return response.data.atributos;
    }
  } catch (error) {
    return false;
  }
};

const createAttribute = async (params) => {
  try {
    const response = await apiService.post('/mapavalor/atributos/', params);
    if (response.status === 200) {
      return response.data.atributos;
    }
  } catch (error) {
    return false;
  }
};

const updateAttribute = async (params) => {
  try {
    const response = await apiService.put('/mapavalor/atributos/', params);
    if (response.status === 200) {
      return response.data.atributos;
    }
  } catch (error) {
    return false;
  }
};

const deleteAttribute = async (id) => {
  try {
    const response = await apiService.delete(`/mapavalor/atributos/?id=${id}`);
    if (response.status === 200) {
      return response.data.atributos;
    }
  } catch (error) {
    return false;
  }
};

const getFeatures = async () => {
  try {
    const response = await apiService.get('/mapavalor/caracteristicas/');
    if (response.status === 200) {
      return response.data.atributos;
    }
  } catch (error) {
    return false;
  }
};

const saveImage = async (params) => {
  try {
    const param = {
      imagen: params.archivo,
    };
    const response = await apiService.post('/mapavalor/imagenes/', param);
    if (response.status === 200) {
      return response.data.success;
    }
  } catch (error) {
    return false;
  }
};

const updateVehicle = async (params) => {
  try {
    const response = await apiService.put('/mapavalor/vehiculos/', params);
    if (response.status === 200) {
      return response.data;
    }
  } catch (error) {
    return false;
  }
};

const deleteVehicle = async (params) => {
  try {
    const response = await apiService.delete(
      `/mapavalor/vehiculos/?vehiculo_id=${params}`,
    );
    if (response.status === 200) {
      return response.data;
    }
  } catch (error) {
    return false;
  }
};

const valueMapsService = {
  saveImage,
  getVehicles,
  createValueMap,
  getValueMap,
  deleteVehicle,
  createVehicle,
  updateVehicle,
  getProperties,
  getAttributes,
  getFeatures,
  getVehiclesBySegmentation,
  createAttribute,
  updateAttribute,
  deleteAttribute,
  deleteValueMap,
};

export default valueMapsService;
